import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import ProductType, {
  ActivateEcomProduct,
  AddProduct,
  AddProductVariant,
  ChangeProductEcomStatus,
  ChangeProductStatus,
  DeleteVariant,
  GetBuyerList,
  GetPoProductList,
  GetProduct,
  GetProductDetails,
  GetVariantProduct,
  MapProduct,
  UpdateProduct,
  UpdateProductImage,
  UpdateProductVariant,
} from "../types/ProductType";
import { getCookie } from "../../utils/CookieAction";
import LogoutAction from "./LogoutAction";
import { toast } from "react-toastify";

interface Action {
  type: string;
  payload?: any;
  message?: string;
}

const ProductAction = {
  addProduct:
    (data: AddProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        console.log(data);
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "product/create",
          {
            product_name: data.product_name,
            barcode: data.barcode,
            selling_qty: data.selling_qty,
            description: data.description,
            landing_cost: data.ex_factory_price,
            tax: data.tax,
            vendor_id: data.vendor_id,
            category_id: data.category_id,
            sub_category_id: data.sub_category_id,
            child_category_id: data.child_category_id,
            is_variant: data.is_variant,
            product_specification: data.product_specification,
            product_image: data.product_image,
            product_code: data.product_code,
            gallery: data.gallery,
            min_sale_qty: data.min_sale_qty,
            mrp: data.mrp,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: ProductType.SET_ADD_PRODUCT,
          });
          toast.success(result.data.msg);
        } else {
          toast.error(result.data.msg);
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getProduct:
    (data: GetProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getProductData: any = await axios.post(
          BASE_URL + "product/list",
          {
            search: data.search,
            limit: data.limit,
            page: data.page,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: ProductType.SET_PRODUCT_LIST,
          payload: {
            data: getProductData.data.data.data,
            currentPage: getProductData.data.data.current_page,
            lastPage: getProductData.data.data.last_page,
            totalData: getProductData.data.data.total,
            from: getProductData.data.data.from,
            to: getProductData.data.data.to,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  downloadProductPDF:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(BASE_URL + "account/pdfGenerate", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        console.log({ result });

        dispatch({
          type: ProductType.DOWNLOAD_PRODUCT_LIST,
          payload: {
            data: result.data.data,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  addProductVariant:
    (data: AddProductVariant): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        await axios.post(
          BASE_URL + "product/createVariants",
          {
            product_id: data.product_id,
            product_code: data.product_code,
            barcode: data.barcode,
            product_size: data.product_size,
            product_color: data.product_color,
            qty: data.qty,
            mrp: data.mrp,
            landing_cost: data.landing_cost,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "application/json",
            },
          }
        );

        dispatch({
          type: ProductType.SET_ADD_VARIANT,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getVariantProduct:
    (data: GetVariantProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getVariantProductData: any = await axios.get(
          BASE_URL + "product/listVariants/" + data.productId,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: ProductType.SET_VARIANT_PRODUCT_LIST,
          payload: getVariantProductData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  changeStatus:
    (data: ChangeProductStatus): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getVariantProductData: any = await axios.get(
          BASE_URL +
            "product/changeProductStatus/" +
            data.id +
            "/" +
            data.status,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: ProductType.CHANGE_PRODUCT_STATUS,
          payload: {
            id: data.id,
            status: data.status,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  addActivateProduct:
    (data: ActivateEcomProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        await axios.post(
          BASE_URL + "product/activate-ecom",
          {
            id: data.id,
            barcode: data.barcode,
            description: data.description,
            selling_price: data.selling_price,
            tax: data.tax,
            category_id: data.category_id,
            sub_category_id: data.sub_category_id,
            child_category_id: data.child_category_id,
            is_variant: data.is_variant,
            product_specification: data.product_specification,
            product_image: data.product_image,
            status: data.status,
            gallery: data.gallery,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );

        dispatch({
          type: ProductType.SET_ACTIVATE_ECOM_PRODUCT,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getColors:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getColors: any = await axios.get(BASE_URL + "get-colors", {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        dispatch({
          type: ProductType.SET_COLORS,
          payload: getColors.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  deleteVariant:
    (data: DeleteVariant): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getVariantProductData: any = await axios.get(
          BASE_URL + "product/deleteVariants/" + data.id,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        // if (getVariantProductData.status) {
        dispatch({
          type: ProductType.DELETE_VARIANT,
          payload: {
            id: data.id,
          },
        });
        // }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updateProductVariant:
    (data: UpdateProductVariant): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const updateVariant: any = await axios.post(
          BASE_URL + "product/updateVariants/" + data.id,
          {
            product_id: data.product_id,
            product_code: data.product_code,
            barcode: data.barcode,
            product_size: data.product_size,
            product_color: data.product_color,
            qty: data.qty,
            mrp: data.mrp,
            landing_cost: data.landing_cost,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );

        dispatch({
          type: ProductType.UPDATE_VARIANT,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getProductForPO:
    (data: GetPoProductList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "po_product/list",
          {
            category_id: data.categoryId ? data.categoryId : 0,
            sub_category_id: data.subCategoryId ? data.subCategoryId : 0,
            child_category_id: data.childCategoryId ? data.childCategoryId : 0,
            vendor_id: data.vendorId ? data.vendorId : 0,
            seller_unique_id: data.sellerUniqueId ? data.sellerUniqueId : 0,
            city: data.city,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: ProductType.GET_PO_PRODUCT_LIST,
          payload: {
            data: result.data.data.products,
            totalTax: result.data.data.totalTax,
            grandTotal: result.data.data.grandTotal,
            totalQty: result.data.data.totalQty,
            delivery_charge: result.data.data.delivery_charge,
            min_order_amount: result.data.data.min_order_amount,
            terms_conditions: result.data.data.terms_conditions,
            product_view_status: result.data.data.product_view_status,
            requestStatus: result.data.data.requestStatus,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  getProductDetails:
    (data: GetProductDetails): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getProductData: any = await axios.get(
          BASE_URL + "product/details/" + data.id,

          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: ProductType.SET_PRODUCT_DETAILS,
          payload: getProductData.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  updateProduct:
    (data: UpdateProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        // console.log(data);
        // return false;
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        await axios.post(
          BASE_URL + "product/update/" + data.id,
          {
            product_name: data.product_name,
            barcode: data.barcode,
            selling_qty: data.selling_qty,
            description: data.description,
            landing_cost: data.ex_factory_price,
            tax: data.tax,
            vendor_id: data.vendor_id,
            category_id: data.category_id,
            sub_category_id: data.sub_category_id,
            is_variant: data.is_variant,
            product_specification: data.product_specification,
            product_image: data.product_image,
            product_code: data.product_code,
            min_sale_qty: data.min_sale_qty,
            mrp: data.mrp,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );
        dispatch({
          type: ProductType.UPDATE_PRODUCT,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updateProductImage:
    (data: UpdateProductImage): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        console.log({
          product_image: data.product_image,
        });
        await axios.post(
          BASE_URL + "product/update-image/" + data.id,
          {
            product_image: data.product_image,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );
        dispatch({
          type: ProductType.UPDATE_PRODUCT_IMAGE,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  changeProductEcomStatus:
    (
      data: ChangeProductEcomStatus
    ): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "product/ecom-status/",
          {
            id: data.id,
            product_ecom_status: data.product_ecom_status,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (result.data.status) {
          dispatch({
            type: ProductType.CHANGE_PRODUCT_TYPE,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getBuyerList:
    (data: GetBuyerList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getBuyerData: any = await axios.get(
          BASE_URL + "product/buyer-list/" + data.productId,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        console.log("data", getBuyerData.data.data);

        dispatch({
          type: ProductType.SET_BUYER_LIST,
          payload: {
            data: getBuyerData.data.data,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  mapProduct:
    (data: MapProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "product/map-product/",
          {
            product_id: data.product_id,
            user_id: data.user_id,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (result.data.status) {
          dispatch({
            type: ProductType.MAP_PRODUCT,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default ProductAction;
